module.exports = __webpack_public_path__ + "img/anchor.81ccde90.svg";